module.exports = __webpack_public_path__ + "img/bigquery.05ba3a6c.png";